module.exports = __webpack_public_path__ + "static/media/icons_Bilan blessé médullaire.0fa2180a.svg";